import React from "react";
import styled from "styled-components";

export const CustomInput = (props) => {
  return <Input {...props} />;
};

const Input = styled.input`
  display: inline-block;
  padding-right: 24px;
  max-width: 100%;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  -moz-appearance: textfield; /* For Firefox */
`;
